var map = {
	"./bg-dots.svg": 580,
	"./icon-arrow.svg": 654,
	"./icon-close.svg": 8904,
	"./icon-error.svg": 9656,
	"./icon-facebook.svg": 7487,
	"./icon-hamburger.svg": 4421,
	"./icon-twitter.svg": 7356,
	"./illustration-features-tab-1.svg": 9829,
	"./illustration-features-tab-2.svg": 9338,
	"./illustration-features-tab-3.svg": 7966,
	"./illustration-hero.svg": 3696,
	"./logo-bookmark.svg": 3506,
	"./logo-chrome.svg": 5956,
	"./logo-firefox.svg": 6436,
	"./logo-opera.svg": 5566,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;